import React, { useState, useEffect } from 'react'
// import Payment from './'
import Header from '../Header';
import Menu from '../Menu';
import Engg from './Engg/CompletedApplication';
import MBA from './MbaPgdm/CompletedApplication';
import Other from './Other/CompletedApplication';
import PCB from './PCB/CompletedApplication';
import PCM from './PCM/CompletedApplication';
import axios from 'axios';
import PartialApplicationTable from './PartialApplicationTable';
function PartialStudents() {
    const [state, setState] = useState('engg')
    const [mbaPartial, setMbaPartial] = useState([])
    const [enggPartial, setEnggPartial] = useState([])
    const [pcmPartial, setPcmPartial] = useState([])
    const [pcbPartial, setPcbPartial] = useState([])
    const [otherPartial, setOtherPartial] = useState([])
    const [partial, setPartial] = useState()
    console.log("partial...", partial)
    const mbaUrl = '/mba-students-partial'
    const enggUrl = '/engg-students-partial'
    const pcmUrl = '/pcm-students-partial'
    const pcbUrl = '/pcb-students-partial'
    const otherUrl = '/Other-students-partial'

    const fetchPartial = async () => {
        try {
            const response = await axios.get('/users-without-payment');
            console.log("response...", response.data?.data.users)
            setPartial(response.data?.data.users);
        } catch (error) {
            console.error("Error fetching partial data:", error);
        }
    };
    
    React.useEffect(() => {
        fetchPartial();
    }, [])
    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#F5F7FA' }}>
                <div>




                    <div class="alert alert-dark" role="alert">
                       Total Partial Application
                    </div>
                    {partial?.length ? <PartialApplicationTable data={partial} /> : <p>No partial applications found.</p>}
                    {/* <PartialApplicationTable data={partial} /> */}



                </div>
               
               
            </div>
        </div>
    )
}

export default PartialStudents